<template>
	<div class="box-description mt-5 mb-5">
		<div class="row">

			<div class="col-12 col-service-title">
				<h5>Paquetes de Casa con BlackFon</h5>
			</div>

			<offers-slider class="col-12 col-carousel" ofertaTipo="planCasa" />

		</div>
	</div>
</template>

<script>
import offersSlider from '../../daniel/offers-slider.vue';
export default {
  components: { offersSlider },
};
</script>


